import React from 'react'
import Header, { HeaderProps } from 'tennders-stracture/layouts/views/header/Header'

const GeneralLayoutHeader = (props: HeaderProps) => <Header {...props} />

GeneralLayoutHeader.displayName = 'GeneralLayoutHeader'
export default GeneralLayoutHeader
